module.exports = __webpack_public_path__ + "img/arrow_white.76e24561.svg";